import {EntityApiService, ApiClientService} from '@dofleini/security';

class AuditorAuditsApiService extends EntityApiService {

    getOneAudit = ({auditId}) => ApiClientService.get(this.getPath(`/${auditId}`));

    getOneAuditForPreview = ({auditId, preview}) => {
      if (preview) {
        return ApiClientService.get(this.getPath(`/${auditId}/get-preview`));
      }
      return ApiClientService.get(this.getPath(`/${auditId}`));
    }

    addAnswer = (params) => ApiClientService.post(this.getPath(`/${params?.id}/answer/add`), params);

    updateAnswer = (params) => {
      const {answerId} = params;
      const {id: auditId} = params;

      delete params?.answerId;
      params._id = answerId;

      return ApiClientService.patch(this.getPath(`/${auditId}/answer/${answerId}/update`), params);
    }

    removeAnswer = (params) => ApiClientService.delete(this.getPath(`/${params?.id}/answer/${params?.answerId}/remove`));

    getSectionsManifest = ({ auditId }) => ApiClientService.get(this.getPath(`/${auditId}/sections/manifest`));

    getAllSections = ({ auditId, preview, sectionIds }) => {
      if (preview) return ApiClientService.post(this.getPath(`/${auditId}/preview`));
      return ApiClientService.post(
        this.getPath(`/${auditId}/questions-answers`),
        sectionIds?.length ? { sectionIds } : undefined
      );
    };

    addIssues = ({auditId, questionId, ...params}) => ApiClientService.post(this.getPath(`/${auditId}/questions/${questionId}/issues-tasks-all`), params);

    addAndRemoveTasks = ({auditId, questionId, sectionId,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/issues-tasks`), params);

    updateName = ({auditId, questionId, sectionId,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/update-issue-name`), params);

    solvedInPlace = ({auditId, questionId, sectionId,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/solved-in-place`), params);

    updateTaskName = ({auditId, questionId, sectionId,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/update-task-name`), params);

    updateDescription = ({auditId, questionId, sectionId,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/update-issue-description`), params);

    manageEvidence = ({auditId, questionId, sectionId, options, ...params}) => {
      return ApiClientService.post(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/evidences`),
        params?.data,
        {
          headers: options?.headers
        });
    }

    manageNote = ({auditId, questionId, sectionId,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/note`), params);

    manageImages = ({auditId, questionId, sectionId, options, ...params}) => {
      return ApiClientService.post(this.getPath(`/${auditId}/sections/${sectionId}/questions/${questionId}/note-images`),
        params?.data,
        {
          headers: options?.headers
        });
    }

    finishAudit = ({auditId, ...params}) => ApiClientService.patch(this.getPath(`/${auditId}/finished`), params);

    executeAudit = ({auditId, use_previous = false,...params}) => ApiClientService.patch(this.getPath(`/${auditId}/execute?use_previous=${use_previous}`), params);

    addMetadataValue = ({auditId, ...params}) => ApiClientService.post(this.getPath(`/${auditId}/cover/update`), params);

    reOpen = ({auditId, ...params}) => ApiClientService.patch(this.getPath(`/${auditId}/reopen`), params);

    updateContacts = ({auditId, ...params}) => ApiClientService.post(this.getPath(`/${auditId}/contact-field/update`), params);

    checkScore = (params) => ApiClientService.post(this.getPath('/check-score'), params);

    changeDateInRunning = ({_id, ...params}) => ApiClientService.patch(this.getPath(`/run/${_id}`), params);

    removePdfReport = ({auditId, ...params}) => ApiClientService.patch(this.getPath(`/remove-pdf/${auditId}`), params);

}

export default new AuditorAuditsApiService('/ms-core/api/audits');
